<rr-icon
  name="user"
  class="defaultuser"
  *ngIf="
    !user?.avatar &&
    (!user?.prename ||
      !user?.lastname ||
      user?.prename == '' ||
      user?.lastname == '')
  "
></rr-icon>
<div
  class="defaultuser tiny"
  *ngIf="!user?.avatar && user?.prename != '' && user?.lastname != ''"
>
  {{ user?.prename[0] }}{{ user?.lastname[0] }}
</div>
<img
  class="avatar"
  *ngIf="user?.avatar"
  [src]="
    serverurl + '/public/avatars/' + user?.id + '.png?' + user.refreshtoken ||
    ''
  "
  alt="User Avatar"
/>
